/* eslint-disable */
import * as React from 'react';
import { MenuItem } from '@mui/material';
import { matchPath, useLocation, useNavigate } from 'react-router-dom';
import { AuthPAGES, FlorencePAGES } from '../../../tfa-auth/constants/pages';
import { AuthContext } from '../../../tfa-auth/contexts/authContext';
import Menu from '@mui/material/Menu';
import AccountCircle from '@mui/icons-material/AccountCircle';
import { AppBar } from '../../styles';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import { PasswordType } from 'src/common/components/tfa-auth/interfaces/IPassType';
import { ReactComponent as LogoBlue } from '../../../../assets/icons/logo_blue.svg';
import { ReactComponent as UserIconWhite } from '../../../../assets/icons/user_icon_white.svg';
import HeaderMenu from '../HeaderMenu/HeaderMenu';
import { UserMenuOptions } from '../../../../../florence/constants/UserMenuOptions';
import { useAppDispatch, useAppSelector } from '../../../../hooks/reduxHooks';
import HeaderBackButton from './HeaderBackButton';
import florenceApi from '../../../../apis/FlorenceApi';

type HeaderProps = {
  handleDrawerOpen: () => void;
  openSide: boolean;
  hasBurger: boolean;
  hasMail: boolean;
  hasNotification: boolean;
  hasAvatar: boolean;
  hasSearch: boolean;
  showMenu?: boolean;
  showBackButton?: boolean;
};

export const Header: React.FC<HeaderProps> = (props) => {
  const authContext = React.useContext(AuthContext);
  const { pathname } = useLocation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const isResultsPath = matchPath(FlorencePAGES.results, pathname);
  const isUploadsPath = matchPath(FlorencePAGES.upload, pathname);
  const isSheetsPath = matchPath(FlorencePAGES.savedSheet, pathname);
  const isEditSheetPath = matchPath(FlorencePAGES.editSheet, pathname);
  const isEditOpNotePath = matchPath(FlorencePAGES.editOPNote, pathname);

  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
  const { user } = useAppSelector((state) => state.model);

  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] =
    React.useState<null | HTMLElement>(null);

  const isMenuOpen = Boolean(anchorEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

  const handleProfileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    handleMobileMenuClose();
  };

  const menuId = 'primary-search-account-menu';
  const renderMenu = (
    <HeaderMenu
      anchorEl={anchorEl}
      id={menuId}
      handleClose={handleMenuClose}
      open={isMenuOpen}
      handleSelectedItem={async (item: UserMenuOptions) => {
        if (item == UserMenuOptions.Account) {
          navigate(`${AuthPAGES.checkPassword}/${PasswordType.CHANGE}`);
        } else if (item === UserMenuOptions.Subscription) {
          navigate(`${FlorencePAGES.subscriptions}`);
        } else if (item === UserMenuOptions.ScanPackage) {
          navigate(`${FlorencePAGES.scanPackage}`);
        } else if (item == UserMenuOptions.Logout) {
          authContext.signOut();
          navigate(AuthPAGES.signIn);
          dispatch(florenceApi.util.resetApiState());
        } else if (item === UserMenuOptions.TFactor) {
          navigate(`${FlorencePAGES.tFactorAuth}`);
        }
        return;
      }}
    />
  );

  const mobileMenuId = 'primary-search-account-menu-mobile';
  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      <MenuItem onClick={handleProfileMenuOpen}>
        <IconButton
          size='large'
          aria-label='account of current user'
          aria-controls='primary-search-account-menu'
          aria-haspopup='true'
          color='inherit'
        >
          <AccountCircle />
        </IconButton>
        <p>Profile</p>
      </MenuItem>
    </Menu>
  );

  return (
    <>
      <CssBaseline />
      <AppBar position='fixed' open={props.openSide} className='header-appbar'>
        <Toolbar>
          {props.showMenu && (
            <IconButton
              size='large'
              edge='start'
              color='inherit'
              aria-label='open drawer'
              sx={{ mr: 2 }}
              onClick={props.handleDrawerOpen}
            >
              <MenuIcon />
            </IconButton>
          )}

          <a href={FlorencePAGES.home}>
            <LogoBlue />
          </a>

          {(isResultsPath ||
            isUploadsPath ||
            isSheetsPath ||
            isEditSheetPath ||
            isEditOpNotePath) && (
            <HeaderBackButton route={FlorencePAGES.home} title='Back home' />
          )}

          <Box sx={{ flexGrow: 1 }} />
          <Box
            sx={{
              display: { xs: 'flex', md: 'flex', alignItems: 'center' },
            }}
          >
            {props.hasAvatar && (
              <>
                <Typography
                  sx={{ mr: '12px', display: { xs: 'none', md: 'block' } }}
                  color='text.primary'
                >
                  {user?.fullName}
                </Typography>
                <IconButton
                  aria-label='account of current user'
                  aria-controls={menuId}
                  aria-haspopup='true'
                  onClick={handleProfileMenuOpen}
                  color='inherit'
                >
                  <UserIconWhite />
                </IconButton>
              </>
            )}
          </Box>
        </Toolbar>
      </AppBar>
      {renderMobileMenu}
      {renderMenu}
    </>
  );
};
